import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltActivityLogHeaderWireframe from './VeltActivityLogHeaderWireframe/VeltActivityLogHeaderWireframe';
import VeltActivityLogListWireframe from './VeltActivityLogListWireframe/VeltActivityLogListWireframe';
import VeltActivityLogLoadingWireframe from './VeltActivityLogLoadingWireframe/VeltActivityLogLoadingWireframe';
import VeltActivityLogEmptyWireframe from './VeltActivityLogEmptyWireframe/VeltActivityLogEmptyWireframe';
var VeltActivityLogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-activity-log-wireframe", __assign({}, transformedProps), children));
};
VeltActivityLogWireframe.Header = VeltActivityLogHeaderWireframe;
VeltActivityLogWireframe.List = VeltActivityLogListWireframe;
VeltActivityLogWireframe.Loading = VeltActivityLogLoadingWireframe;
VeltActivityLogWireframe.Empty = VeltActivityLogEmptyWireframe;
export default VeltActivityLogWireframe;
